import Circle from '@uiw/react-color-circle';
import { FloatingFormItem } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Input, Modal, ModalProps, Row } from 'antd';
import { useEffect } from 'react';
import { ColorResult } from '@uiw/color-convert';
import {
  useInstallmentTagsCreate,
  useInstallmentTagsUpdate,
} from '@/core/domain/financial/InstallmentTags/InstallmentTags.hooks';
import {
  InstallmentTag,
  InstallmentTagsFormValues,
} from '@/core/domain/financial/InstallmentTags/InstallmentTags.type';

interface Props extends Omit<ModalProps, 'onCancel'> {
  tagDetail?: InstallmentTag;
  onCancel: VoidFunction;
}

export default function TagsAccountsPayableAndReceivableModal(props: Props) {
  const [form] = Form.useForm<InstallmentTagsFormValues>();
  const defaultEmptyError = useDefaultEmptyFieldError();

  const create = useInstallmentTagsCreate();
  const update = useInstallmentTagsUpdate();

  function handleCancel() {
    form.resetFields();
    props.onCancel();
  }

  async function handleOk() {
    const values = await form.validateFields();

    if (props?.tagDetail?.id) {
      await update.mutateAsync({ id: props.tagDetail.id, ...values });
    } else {
      await create.mutateAsync(values);
    }

    handleCancel();
  }

  useEffect(() => {
    if (props?.tagDetail) {
      form.setFieldsValue(props.tagDetail);
    }
  }, [props?.tagDetail]);

  return (
    <Modal
      {...props}
      title={`${!props?.tagDetail?.id ? 'Criação' : 'Edição'} da etiqueta`}
      width={500}
      okText={!props?.tagDetail?.id ? 'Criar' : 'Editar'}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={create.isLoading || update.isLoading}
    >
      <Form form={form} layout="vertical">
        <Row gutter={[12, 12]}>
          <Col span={24}>
            <FloatingFormItem
              name="name"
              label="Descrição"
              rules={[defaultEmptyError]}
            >
              <Input maxLength={50} />
            </FloatingFormItem>
          </Col>

          <Form.Item
            name="color"
            label="Cor"
            getValueFromEvent={(e: ColorResult) => {
              return e.hex;
            }}
            rules={[defaultEmptyError]}
            valuePropName="color"
          >
            <Circle
              colors={[
                '#F44336',
                '#E91E63',
                '#9C27B0',
                '#673AB7',
                '#3F51B5',
                '#2196F3',
                '#03A9F4',
                '#00BCD4',
                '#009688',
                '#4CAF50',
                '#8BC34A',
                '#CDDC39',
                '#FFEB3B',
                '#FFC107',
                '#FF9800',
                '#FF5722',
                '#795548',
                '#607D8B',
              ]}
            />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
}
